module.exports = __webpack_public_path__ + "static/media/18.8375e368.jpeg";